import { Dropdown, Accordion } from "react-bootstrap";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
const AccordionUsers = ({
  keyProp,
  user,
  nameRole,
  handleShowUpdate,
  handleShowUpdatePassword,
  deleteUser,
  nameBrands,
}) => {
  return (
    <div className="row">
      <div className="col-md-12">
        <Accordion className="mb-4 w-100 m-auto" alwaysOpen>
          <Accordion.Item eventKey={keyProp} className="mb-4">
            <div className="row w100 align-items-center">
              <div className="col-md-10">
                <Accordion.Header as="div">
                  <div className="row w100">
                    <div className="col-12 ">
                      <span className="accordion-title accordion-user-name me-3">
                        {user.name}
                      </span>{" "}
                      /{" "}
                      <span className="accordion-user-role fw-300 ms-3">
                        {nameRole}
                      </span>
                    </div>
                  </div>
                </Accordion.Header>
              </div>
              <div className="col-2 text-end pt-2">
                <Dropdown>
                  <Dropdown.Toggle>
                    <MoreVertIcon />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        handleShowUpdate(user);
                      }}
                    >
                      <EditOutlinedIcon className="grey" /> Modifier
                      l'utilisateur
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        handleShowUpdatePassword(user);
                      }}
                    >
                      <EditOutlinedIcon className="grey" /> Modifier mot de
                      passe
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        deleteUser(user.id);
                      }}
                    >
                      <DeleteOutlineOutlinedIcon className="red" /> Supprimer
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="container-fluid">
              <Accordion.Body>
                <div className="row">
                  <div className="col-md-6  have-border-top pt-3">
                    <div className="data-label">Nom Prénom</div>
                    <p>{user.name}</p>
                    <div className="data-label">Email</div>
                    <p>{user.email}</p>
                  </div>
                  <div className="col-md-6 have-border-top have-border-left pt-4">
                    <div className="data-label px-3">Rôles</div>
                    <div className="grey  px-3">{nameRole}</div>
                    {user.role === 5 && (
                      <>
                        <div className="data-label mt-3 px-3">
                          Marque(s) associé(s)
                        </div>
                        {nameBrands(user).map((e, key) => (
                          <div className="grey  px-3" key={key}>
                            {e}
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              </Accordion.Body>
            </div>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default AccordionUsers;
